import { useRef, useCallback } from "react";
import { createTimer } from "@flights/web-api-utils-universal";
export default function useTimer() {
    const timerRef = useRef(null);
    const start = useCallback(() => {
        if (!timerRef.current) {
            timerRef.current = createTimer();
        }
    }, []);
    const stop = useCallback(() => {
        if (!timerRef.current)
            return undefined;
        const elapsed = timerRef.current();
        timerRef.current = null;
        return elapsed;
    }, []);
    const reset = useCallback(() => {
        timerRef.current = null;
    }, []);
    return { start, stop, reset };
}
